import { render, staticRenderFns } from "./VoiceSelect.vue?vue&type=template&id=275b3d02&"
import script from "./VoiceSelect.vue?vue&type=script&lang=js&"
export * from "./VoiceSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports